import { authHeader, BASE_URL, bestEffortRequest } from '@helpers/api';

export interface SupportChatIdentity {
    customerId: string;
    name: string | null;
    email: string | null;
    timestamp: number;
    signature: string;
}

export interface SupportChatSettings {
    channelId: string;
    identity: SupportChatIdentity | null;
}

function get(signedIn: boolean): Promise<SupportChatSettings | null> {
    return bestEffortRequest(`${BASE_URL}api/support-chat`, {
        method: 'GET',
        headers: signedIn ? authHeader() : {},
    });
}

export const supportChatService = {
    get,
};
